export default "__VITE_ASSET__D7ha9FdW__"